var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1056,
    height: 1314,
    viewBox: "0 0 1056 1314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M728.41 751.308H633.925L588.207 833.6L633.925 915.893H728.41L774.128 833.6L728.41 751.308Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M419.05 751.308H324.566L278.848 833.6L324.566 915.893H419.05L464.768 833.6L419.05 751.308Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263.608 664.439H169.124L123.406 746.732L169.124 829.024H263.608L309.326 746.732L263.608 664.439Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.124 652.246L263.609 652.246L309.327 569.953L263.609 487.66L169.124 487.66L123.406 569.953L169.124 652.246Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M784.794 652.246L879.278 652.246L924.996 569.953L879.278 487.66L784.794 487.66L739.076 569.953L784.794 652.246Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M324.564 560.815L419.048 560.815L464.766 478.523L419.048 396.23L324.564 396.23L278.846 478.523L324.564 560.815Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M635.451 560.815L729.935 560.815L775.653 478.523L729.935 396.23L635.451 396.23L589.733 478.523L635.451 560.815Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M480.006 475.474L574.491 475.474L620.209 393.181L574.491 310.889L480.006 310.889L434.288 393.181L480.006 475.474Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M879.282 664.439H784.798L739.08 746.732L784.798 829.024H879.282L925 746.732L879.282 664.439Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M575.291 841.22H476.16L428.194 923.513L476.16 1005.81H575.291L623.258 923.513L575.291 841.22Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M696.659 1173.43H665.681L650.691 1199.34L665.681 1225.24H696.659L711.649 1199.34L696.659 1173.43Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M357.846 140.204L388.824 140.204L403.813 114.297L388.824 88.3904L357.846 88.3904L342.856 114.297L357.846 140.204Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M852.102 1085.04H821.124L806.134 1110.95L821.124 1136.85H852.102L867.092 1110.95L852.102 1085.04Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M202.403 228.586L233.381 228.586L248.371 202.679L233.381 176.772L202.403 176.772L187.413 202.679L202.403 228.586Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M233.382 1085.04H202.404L187.414 1110.95L202.404 1136.85H233.382L248.372 1110.95L233.382 1085.04Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M821.123 228.586L852.101 228.586L867.091 202.679L852.101 176.772L821.123 176.772L806.133 202.679L821.123 228.586Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M388.823 1173.43H357.845L342.855 1199.34L357.845 1225.24H388.823L403.813 1199.34L388.823 1173.43Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M665.681 140.204L696.659 140.204L711.649 114.297L696.659 88.3904L665.681 88.3904L650.691 114.297L665.681 140.204Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M544.267 1261.82H513.288L498.299 1287.73L513.288 1313.64H544.267L559.256 1287.73L544.267 1261.82Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M510.237 51.814L541.216 51.814L556.205 25.907L541.216 6.73541e-05L510.237 6.46459e-05L495.248 25.907L510.237 51.814Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M562.104 1048.47H492.403L458.677 1107.91L492.403 1167.34H562.104L595.831 1107.91L562.104 1048.47Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M492.403 268.216L562.104 268.216L595.831 208.782L562.104 149.349L492.403 149.349L458.676 208.782L492.403 268.216Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M872.986 871.7H803.284L769.558 931.134L803.284 990.567H872.986L906.712 931.134L872.986 871.7Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M401.216 969.232H345.455L318.473 1016.47L345.455 1063.72H401.216L428.197 1016.47L401.216 969.232Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M242.677 886.931H193.111L169.128 929.601L193.111 972.271H242.677L266.66 929.601L242.677 886.931Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M242.457 429.881L267.24 386.956L242.278 344.85L193.333 344.285L168.55 387.21L193.512 429.316L242.457 429.881Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.34 786.359H962.676L937.193 832.078L962.676 877.796H1015.34L1040.82 832.078L1015.34 786.359Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.834 786.359H39.1707L13.6885 832.078L39.1707 877.796H91.834L117.316 832.078L91.834 786.359Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9272 524.182L118.259 478.575L91.4069 433.647L39.0727 432.856L12.7411 478.464L39.593 523.392L91.9272 524.182Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M937.741 478.577L964.073 524.185L1016.41 523.394L1043.26 478.467L1016.93 432.859L964.593 433.65L937.741 478.577Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M116.264 606.527H57.4047L28.9246 658.341L57.4047 710.155H116.264L144.744 658.341L116.264 606.527Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M997.104 606.527H938.245L909.765 658.341L938.245 710.155H997.104L1025.58 658.341L997.104 606.527Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M709.051 969.232H653.29L626.309 1016.47L653.29 1063.72H709.051L736.032 1016.47L709.051 969.232Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M653.288 344.416L709.049 344.417L736.03 297.174L709.049 249.932L653.288 249.932L626.306 297.174L653.288 344.416Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M345.452 344.416L401.214 344.417L428.195 297.174L401.214 249.932L345.452 249.932L318.471 297.174L345.452 344.416Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M803.287 441.946L872.988 441.946L906.715 382.513L872.988 323.079L803.287 323.079L769.56 382.513L803.287 441.946Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M769.558 664.444H275.802L318.124 739.117H423.145L474.872 825.981H575.191L625.35 739.117H727.236L769.558 664.444Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M278.85 652.251L769.558 652.251L727.497 577.578L623.124 577.578L571.717 490.714L472.017 490.714L422.167 577.578L320.91 577.578L278.85 652.251Z",
    fill: "#E2D0FF",
    fillOpacity: 0.08
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackground);
export default __webpack_public_path__ + "static/media/logo-background.4bfb4ab9ba86aef2bda4df5b5784345d.svg";
export { ForwardRef as ReactComponent };